export default __webpack_public_path__ + "static/media/Quiken_Camioneta-18.a0825ce3.svg";